import { Post, Get, Patch, Put, Delete, Download, ax } from './http';
import { type } from './interface';
import qs from 'qs';
export namespace ProjectInquiry {
    /**
  * 新增
  */
    export var AddProjectInquiry = (body: any): Promise<any> => {
        return Post(`/msls/ProjectInquiry/Add`, body);
    };

    /**
    * 获取询价列表
    */
    export var GetList = (query: any): Promise<any> => {
        return Get(`/msls/ProjectInquiry/GetList?${qs.stringify(query)}`, {});
    };
    /**
    * 获取询价详情
    */
    export var GetDetail = (ProjectInquiryId: string): Promise<any> => {
        return Get(`/msls/ProjectInquiry/GetDetail/${ProjectInquiryId}`, {});
    };
    /**
     * 编辑
     */
    export var EditProjectInquiry = (id: string, body: any): Promise<any> => {
        return Put(`/msls/ProjectInquiry/Edit/${id}`, body);
    };
    /**
    * 删除
    */
    export var DelProjectInquiry = (id: string): Promise<any> => {
        return Delete(`/msls/ProjectInquiry/Delete/${id}`, {});
    };
    /**
     * 终结
     */
    export var EndProjectInquiry = (id: string): Promise<any> => {
        return Put(`/msls/ProjectInquiry/End/${id}`, {});
    };

    /**
     * 招标结束
     */
    export var FinishProjectInquiry = (id: string): Promise<any> => {
        return Put(`/msls/ProjectInquiry/Finish/${id}`, {});
    };


    /**
    * 获取报价
    */
    export var GetQuoteDetail = (id, body): Promise<any> => {
        return Get(`/msls/ProjectInquiry/GetQuoteDetail/${id}?${qs.stringify(body)}`, {});
    };

    /**
 * 获取字典数据
 */
    export var GetDicDetailList = (query: any): Promise<any> => {
        return Get(`/msls/DataDictionary/GetDicDetailList?${qs.stringify(query)}`, {});
    };

    /**
    * 一键催报
    */
    export var Urge = (id: string): Promise<any> => {
        return Post(`/msls/ProjectInquiry/Urge/${id}`, {});
    };

    /**
* 退回报价，让承运商重新报价
*/
    export var BackQuote = (body: any): Promise<any> => {
        return Post(`/msls/ProjectInquiry/BackQuote`, body);
    };


    /**
  * 中标
  */
    export var Win = (body: any): Promise<any> => {
        return Post(`/msls/ProjectInquiry/Win`, body);
    };

    /**
* 取消中标
*/
    export var CancelWin = (body: any): Promise<any> => {
        return Post(`/msls/ProjectInquiry/CancelWin`, body);
    };

    /**
 * 导出
 */
    export var Export = (query: any): Promise<any> => {
        return Download(`/msls/ProjectInquiry/Export?${qs.stringify(query)}`, {});
    };

    /**
* 导出报价
*/
    export var ExportQuotes = (ProjectInquiryId: string, body: any): Promise<any> => {
        return Download(`/msls/ProjectInquiry/ExportQuotes/${ProjectInquiryId}?${qs.stringify(body)}`, {});
    };

    /**
* 导出模板
*/
    export var ExportTemplate = (query: any): Promise<any> => {
        return Download(`/msls/ProjectInquiry/ExportTemplate?${qs.stringify(query)}`, {});
    };

    /**
* 批量导入
*/
    export var ImportTemplate = (body: any): Promise<any> => {
        return Post(`/msls/ProjectInquiry/ImportTemplate`, body);
    };

    export var GetContacters = (query: any): Promise<any> => {
        return Get(`/msls/ProjectInquiry/GetContacters?${qs.stringify(query)}`, {});
    };











}
